import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=d24cb976&"
import script from "./SubmitBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports